function setPilingGraphic(mars3d) {
  /**
   * 打桩对象
   *
   * @class PilingGraphic
   * @extends {mars3d.graphic.BasePointEntity}
   */
  class PilingGraphic extends mars3d.graphic.BasePointEntity {
    /**
     * 对象添加到图层前创建一些对象的钩子方法，
     * 只会调用一次
     * @return {void}  无
     * @private
     */
    _mountedHook() {
      this._models = []

      const point = this.point // 位置
      const floorHeight = this.style.spacing // 每层层高,单位:米
      const floorCount = this.style.count // 总层数

      // 增加层
      for (let i = 0; i < floorCount; i++) {
        const alt = point.alt + i * floorHeight
        const model = new mars3d.graphic.ModelEntity({
          position: [point.lng, point.lat, alt],
          style: this.style,
          attr: {
            origAlt: alt // 记录原始高度
          }
        })
        model.show = false
        this._models.push(model)
      }
    }

    /**
     * 对象添加到图层上的创建钩子方法，
     * 每次add时都会调用
     * @return {void}  无
     * @private
     */
    _addedHook() {
      this._models.forEach((model) => {
        this._layer.addGraphic(model)
      })
    }

    /**
     * 对象从图层上移除的创建钩子方法，
     * 每次remove时都会调用
     * @return {void}  无
     * @private
     */
    _removedHook() {
      this._models.forEach((model) => {
        this._layer.removeGraphic(model)
      })
    }

    /**
     * 还原重置所有楼层
     * @return {void}  无
     */
    reset() {
      const point = this.point // 楼栋位置

      for (let i = 0; i < this._models.length; i++) {
        const model = this._models[i]

        model.show = false
        model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt)
      }
    }

    /**
     * 显示指定桩层
     *
     * @param {Number} floorNum 指定显示的层，第1层开始
     * @param {Number} [time=1] 需要时间,单位:秒
     * @return {void}  无
     */
    showFloor(floorNum, time = 1, floorHeight = 3.5) {
      floorNum--

      const point = this.point // 位置

      const model = this._models[floorNum]
      if (floorNum === 0) {
        model.show = true
      } else {
        model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt - floorHeight)
        model.show = true
        model.moveTo({
          position: [point.lng, point.lat, model.attr.origAlt],
          time: time // 移动的时长(单位 秒)
        })
      }
    }

    /**
     * 显示指定桩层
     *
     * @param {Number} floorNum 指定显示的层，第1层开始
     * @param {Number} [time=1] 需要时间,单位:秒
     * @return {void}  无
     */
    showHole(floorNum, time = 1, floorHeight = 3.5, floorCount = 12) {
      floorNum--

      const point = this.point // 位置

      const model = this._models[floorNum]
      if (floorNum === floorCount - 1) {
        model.show = true
      } else {
        model.position = new mars3d.LatLngPoint(point.lng, point.lat, model.attr.origAlt + floorHeight)
        model.show = true
        model.moveTo({
          position: [point.lng, point.lat, model.attr.origAlt],
          time: time // 移动的时长(单位 秒)
        })
      }
    }

  }
  mars3d.graphic.PilingGraphic = PilingGraphic
}

export { setPilingGraphic }



//////////////////
// WEBPACK FOOTER
// ./static/util/Piling.js
// module id = null
// module chunks = 